import { notNull } from "@/app/lib/common/not-null";
import {
    ComponentGeneralDetail,
} from "@/app/lib/generated/graphql-types";
import { MutableDetail } from "../../../types/general/detail/types";

export function mutableDetailFrom(detail: ComponentGeneralDetail): MutableDetail {
    return {
        viewVariant: detail.viewVariant,
        title: detail.title || undefined,
        subtitle: detail.subtitle || undefined,
        description: detail.description || undefined,
        image: detail.image,
        imagePosition: detail.imagePosition || undefined,
        links: detail.links?.filter(notNull) || undefined,
        documents: detail.documents?.filter(notNull) || undefined,
        splitMax: detail.splitMax || 50,
        splitInitial: detail.splitInitial || 50,
    };
}